import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from "./store";

Vue.use(Router)

function checkSession(to, from, next) {
  if(store.state.reservation.code) {
    next(true);
  } else {
    next({
      path: '/'
    });
  }
}

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/reservation",
      name: "reservation",
      component: () =>
        import(/* webpackChunkName: "reservation" */ "./views/Reservation.vue"),
      beforeEnter: checkSession
    },
    {
      path: "/signature",
      name: "signature",
      component: () =>
        import(/* webpackChunkName: "signature" */ "./views/Signature.vue"),
      beforeEnter: checkSession
    },
    {
      path: "/tnc",
      name: "tnc",
      component: () =>
        import(/* webpackChunkName: "signature" */ "./views/TandC.vue")
    }
  ],
  mode: "history"
});
